import { FC, SVGProps } from 'react';

const MediaViewerDownloadIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3 15V15.0798C3 17.1521 3 18.1883 3.40328 18.9798C3.75801 19.676 4.32404 20.242 5.02024 20.5967C5.81171 21 6.84781 21 8.92 21H15.08C17.1522 21 18.1883 21 18.9798 20.5967C19.676 20.242 20.242 19.676 20.5967 18.9798C21 18.1883 21 17.1521 21 15.0798V15"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.78125 11.2066L11.9997 15.5509M11.9997 15.5509L16.2182 11.2066M11.9997 15.5509L12.0002 3"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MediaViewerDownloadIcon;
